import api from '@/libs/api'
import store from '@/store'

const projectId = () => store.state.app.projectId

export default {
  namespaced: true,
  state: {
    fetchingLifecycles: false,
    lifecycles: [],
    resultInfo: {},
    lifecycle: {},
    gettingLifecycle: false,
    addingLifecycle: false,
    updatingifecycle: false,
    deletingifecycle: false,
  },
  mutations: {
    SET_FETCHING_LIFECYCLES(state, value) {
      state.fetchingLifecycles = value
    },
    SET_LIFECYCLES(state, data) {
      state.lifecycles = data.result
      state.resultInfo = data.resultInfo
    },
    SET_GETTING_LIFECYCLE(state, value) {
      state.gettingLifecycle = value
    },
    GET_LIFECYCLE(state, value) {
      state.lifecycle = value
    },
    SET_ADDING_LIFECYCLE(state, value) {
      state.addingLifecycle = value
    },
    SET_UPDATING_LIFECYCLE(state, value) {
      state.updatingifecycle = value
    },
    SET_DELETING_LIFECYCLE(state, value) {
      state.deletingifecycle = value
    },
  },
  actions: {
    fetchLifecycles({ commit }, bucketName) {
      commit('SET_FETCHING_LIFECYCLES', true)
      return new Promise((resolve, reject) => {
        api('storage').get(`/v1/projects/${projectId()}/buckets/${bucketName}/lifecycle`)
          .then(response => {
            commit('SET_LIFECYCLES', response.data)
            resolve(response)
          })
          .catch(error => {
            commit('SET_LIFECYCLES', { result: [], resultInfo: null })
            reject(error)
          })
          .finally(() => { commit('SET_FETCHING_LIFECYCLES', false) })
      })
    },
    getLifecycle({ commit }, query) {
      commit('SET_GETTING_LIFECYCLE', true)
      return new Promise((resolve, reject) => {
        api('storage').get(`/v1/projects/${projectId()}/buckets/${query.bucketName}/lifecycle/${query.id}`)
          .then(response => {
            commit('GET_LIFECYCLE', response.data.result)
            resolve(response)
          })
          .catch(error => {
            commit('GET_LIFECYCLE', {})
            reject(error)
          })
          .finally(() => { commit('SET_GETTING_LIFECYCLE', false) })
      })
    },
    addLifecycle({ commit }, query) {
      commit('SET_ADDING_LIFECYCLE', true)
      return new Promise((resolve, reject) => {
        api('storage').post(`/v1/projects/${projectId()}/buckets/${query.bucketName}/lifecycle`, query.lifecycle)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_ADDING_LIFECYCLE', false) })
      })
    },
    updateLifecycle({ commit }, query) {
      commit('SET_UPDATING_LIFECYCLE', true)
      return new Promise((resolve, reject) => {
        api('storage').put(`/v1/projects/${projectId()}/buckets/${query.bucketName}/lifecycle/${query.lifecycle.id}`, query.lifecycle)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_UPDATING_LIFECYCLE', false) })
      })
    },

    deleteLifecycle({ commit }, query) {
      commit('SET_DELETING_LIFECYCLE', true)
      return new Promise((resolve, reject) => {
        api('storage').delete(`/v1/projects/${projectId()}/buckets/${query.bucketName}/lifecycle/${query.id}`)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_DELETING_LIFECYCLE', false) })
      })
    },
  },

}
